import "./styles/globals.css"
import "./common/api/refresh-token-fetch-dedupe"

import { AuthProvider } from "@propelauth/react"
import * as Sentry from "@sentry/react";
import React from "react"
import ReactDOM from "react-dom/client"
import isDev from "src/common/isDev";
import { ThemeProvider } from "src/context/ThemeContext"
import { getBrandThemeFromDomain } from "src/utils/brandTheme"

import App from "./app"
import config from "./common/config"
import { LogoSpinner } from "./components/ui/logo-spinner"

if (!isDev) {
  Sentry.init({
    dsn: "https://9e1a72209e3c75d24f7fe5aa6e6cd85b@o4509238753689600.ingest.us.sentry.io/4509238754410496",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/api\.(.*\.)?tierzero\.ai\//],

    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <AuthProvider
    authUrl={config.get("AUTH_URL")}
    defaultDisplayWhileLoading={
      <div className="flex h-screen w-full items-center justify-center">
        <LogoSpinner className="text-slate-400" brandTheme={getBrandThemeFromDomain()} />
      </div>
    }
  >
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </AuthProvider>,
);
